import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { EAGLEVIEW } from '@rsos/capstone/src/constants/capabilities';
import { PREMIUM_EAGLEVIEW } from '@rsos/constants/permissions';
import useAccess from '@rsos/utils/useAccess';
import usePortalType from '@rsos/utils/usePortalType';

const createScript = url => {
  const s = document.createElement('script');
  s.src = url;
  s.async = true;
  s.type = 'text/javascript';
  s.crossorigin = 'anonymous|use-credentials';

  return s;
};

const useObliqueImagery = () => {
  const isPremiumUser = usePortalType().isPremiumUser;
  const hasEagleViewAccess =
    !!useAccess(EAGLEVIEW, PREMIUM_EAGLEVIEW) && isPremiumUser;

  useEffect(() => {
    if (hasEagleViewAccess) {
      const loadEVScript = () => {
        window.React = React;
        window.ReactDOM = ReactDOM;
        const embedded_explorer_script = createScript(
          'https://embedded-explorer.eagleview.com/static/embedded-explorer-widget.js',
        );
        embedded_explorer_script.onload = () => {
          window.evScriptLoaded = true;
        };
        document.body.appendChild(embedded_explorer_script);
      };
      loadEVScript();
    }
  }, [hasEagleViewAccess]);
};

export default useObliqueImagery;
